import { createFileRoute } from "@tanstack/react-router";
import PoolRemodeling from "@/pages/PoolRemodeling";
import { buildHead } from "@/lib/seo";

const areaServed = [
  { "@type": "City", name: "Fort Lauderdale" },
  { "@type": "City", name: "Coral Springs" },
  { "@type": "City", name: "Pembroke Pines" },
  { "@type": "City", name: "Weston" },
  { "@type": "City", name: "Miramar" },
  { "@type": "City", name: "Sunrise" },
  { "@type": "City", name: "Davie" },
  { "@type": "City", name: "Miami" },
  { "@type": "City", name: "Tampa" },
  { "@type": "City", name: "Orlando" },
];

export const Route = createFileRoute("/services/pool-remodeling")({
  head: () =>
    buildHead({
      title:
        "Pool Remodeling & Resurfacing in Broward County, FL | Precision Pavers & Pool Design",
      description:
        "Expert pool remodeling and resurfacing in Fort Lauderdale, Coral Springs, Weston, and across Broward County. Diamond Brite finishes, tile replacement, equipment upgrades, and custom design. Family-owned. Free estimates.",
      path: "/services/pool-remodeling",
      jsonLd: [
        {
          "@context": "https://schema.org",
          "@type": "Service",
          serviceType: "Pool Remodeling & Resurfacing",
          provider: {
            "@type": "HomeAndConstructionBusiness",
            name: "Precision Pavers & Pool Design",
            url: "https://precisionpaverspools.com/",
          },
          areaServed,
          url: "https://precisionpaverspools.com/services/pool-remodeling",
          description:
            "Expert Pool Remodeling & Resurfacing services in Broward County, FL. Free estimates.",
        },
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: "https://precisionpaverspools.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Services",
              item: "https://precisionpaverspools.com/services",
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "Pool Remodeling & Resurfacing",
              item: "https://precisionpaverspools.com/services/pool-remodeling",
            },
          ],
        },
      ],
    }),
  component: PoolRemodeling,
});
